import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import ReactPaginate from "react-paginate";
import masterService from "../../Services/masterService";
import { ChangeStatus } from "../../Components";
import Loader from "../../Components/Loader";
import { MdDeleteForever, MdEdit, MdVisibility } from "react-icons/md";
// import { RiBankLine } from "react-icons/ri";

export const CorporatesList = () => {
  const [corporatesList, setCorporatesList] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [countryValue, setCountryValue] = useState("");

  const history = useHistory();
  const imgRef = useRef();

  useEffect(() => {
    getCorporatesList();
  }, [currentPage]);

  const getCorporatesList = (
    countryId = countryValue ? countryValue.label : ""
  ) => {
    let param = { ...pagination, page: currentPage };
    // if (countryId) {
    //     param['search'] = countryId
    //     param['page'] = 1
    // }
    if (pagination.search) {
      param["page"] = 1;
    }
    masterService.get_corporate(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setCorporatesList(res.data);
        setPagination({ ...pagination, ...res.pagination });
      } else {
        setLoader(false);
      }
    });
  };

  const onModalSubmit = () => {
    let postData = {
      id: isModalOpen._id,
      corporate_status:
        isModalOpen.corporate_status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    };
    masterService.update_corporate_status(postData).then((res) => {
      if (res.status) {
        setIsModalOpen(false);
        getCorporatesList();
      }
    });
  };

  const onPageChangeEvent = (e) => {
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  const onSelectCountry = (e) => {
    setCountryValue(e);
    getCorporatesList(e.value);
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="input-group pl-3 w-25">
                <input
                  className="form-control"
                  type="text"
                  placeholder="search..."
                  onChange={(e) =>
                    setPagination({ ...pagination, search: e.target.value })
                  }
                  onKeyPress={(e) => e.key === "Enter" && getCorporatesList()}
                  onKeyUp={(e) =>
                    e.key === "Backspace" &&
                    pagination.search.length <= 0 &&
                    getCorporatesList()
                  }
                ></input>

                <div className="input-group-prepend">
                  <button
                    className="input-group-text pointer search-btn"
                    onClick={() => getCorporatesList()}
                    style={{ backgroundColor: "#e5e4ec" }}
                  >
                    search
                  </button>
                </div>
              </div>
              <button
                className="btn btn-primary w-sm waves-effect waves-light mx-3"
                onClick={() => history.push("/add-corporates")}
              >
                Add Corporates
              </button>
              <input ref={imgRef} type="file" className="d-none" />
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th>Corporate Name</th>
                    <th>Contact No.</th>
                    <th>Email</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {corporatesList.length > 0 &&
                    corporatesList.map((item, key) => (
                      <tr key={key}>
                        <td className="text-body fw-bold">
                          {(pagination.page - 1) * pagination.limit + (key + 1)}
                        </td>
                        <td>{item.corporate_name}</td>
                        <td>+{item.phone_number} </td>
                        <td>{item.corporate_email}</td>
                        <td>
                          <span
                            className={
                              "badge rounded-pill font-size-12 pointer" +
                              (item.corporate_status === "ACTIVE"
                                ? " bg-success"
                                : " bg-soft-danger")
                            }
                            onClick={() => setIsModalOpen(item)}
                          >
                            {item.corporate_status}
                          </span>
                        </td>
                        <td>
                          {/* <RiBankLine
                                                 className="pointer"
                                                 color="#0323fe"
                                                 size="25px"
                                                /> */}
                          {/* Button trigger modal */}
                          {/* <MdDelete color="#fed203" size="30px"/> */}
                          <MdEdit
                            className="pointer"
                            onClick={() =>
                              history.push(
                                "/edit-corporates?id=" + item._id,
                                item
                              )
                            }
                            color="#0323fe"
                            size="25px"
                          />
                          {/* <MdDeleteForever
                            // className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                            className="pointer"
                            color="red"
                            size="25px"
                            onClick={() => setDeleteModalOpen(item)}
                          /> */}
                          <MdVisibility
                            className="pointer"
                            onClick={() =>
                              history.push(
                                "/corporate-details?id=" + item._id,
                                item
                              )
                            }
                            color="#0323fe"
                            size="25px"
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {corporatesList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}
            </div>
          </div>
          {corporatesList.length > 0 &&
            pagination.totalRecord > pagination.limit && (
              <ReactPaginate
                previousLabel={
                  <img
                    src="assets/images/prev.svg"
                    height={15}
                    alt="not found"
                  />
                }
                forcePage={currentPage - 1}
                nextLabel={
                  <img
                    src="assets/images/next.svg"
                    height={15}
                    alt="not found"
                  />
                }
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(e) => onPageChangeEvent(e)}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}
          <Loader isShow={loader} />
        </div>
        {Boolean(isModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isModalOpen)}
            title="Update Status"
            message={`Are you sure want to ${
              isModalOpen.corporate_status === "ACTIVE" ? "Inactive" : "Active"
            } status ?`}
            onSubmitEvent={() => onModalSubmit()}
            handleClose={() => setIsModalOpen(false)}
          />
        )}

        {Boolean(deleteModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(deleteModalOpen)}
            title="Delete"
            message={`Are you sure want to delete?`}
            onSubmitEvent={() => setDeleteModalOpen(false)}
            handleClose={() => setDeleteModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};
